module.exports = __webpack_public_path__ + "static/media/plate@1.5x.fad75517.svg";